import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { getAppTimezone } from './timezone';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Parse a manually typed datetime string using the active locale format.
 */
export const parseDateTimeInput = (text, format, locale) => {
    const trimmed = (text || '').trim();
    if (!trimmed) return null;

    dayjs.locale(locale);

    const candidates = [format];
    if (format.includes(' г.')) {
        candidates.push(format.replace(' г.', '').replace(' ч.', ''));
    }

    for (const fmt of candidates) {
        const parsed = dayjs(trimmed, fmt, locale, true);
        if (parsed.isValid()) {
            return parsed.tz(getAppTimezone());
        }
    }

    const loose = dayjs(trimmed);
    return loose.isValid() ? loose.tz(getAppTimezone()) : null;
};
